import "./NoCatalogPage.scss";
import { Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExclamation} from "@fortawesome/pro-light-svg-icons";

export default function NoCatalogPage(){
	function goToSelect(){
		window.location = "/catalog/select";
	}
	return(
		<div className="no-catalog-access-container">
			<div className="no-catalog-access-inner">
				<FontAwesomeIcon 
					icon={faFileExclamation} 
					style={{
						fontSize: "30px",
						color: "gold",
					}}
				/>
				<div className="error-text">
				The requested catalog is in development and not ready for viewing. Please return to Catalog Select, or contact your Representative for additional information. 
				</div>
				<Button
					className="return-button"
					onClick={goToSelect}
				>
					Return to Catalog Select
				</Button>
			</div>
			
		</div>
	)
}